<template>
  <div class="logos">
    <p>&nbsp;</p>
    <div><img src="../assets/footer/bloomberg.png"></div>
    <p>&nbsp;</p>
    <div><img src="../assets/home/logo.png"></div>
    <p>&nbsp;</p>
  </div>
</template>

<script>
export default {
  name: 'FooterLogos',
  props: {
    cssClass: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.logos {
  @include flex-vertical;
  align-items: center;
  background: black;
  padding: 0 2rem;
}
</style>